export const REQUESTS_HEADER_STRINGS = {
  searchPlaceholder: 'Search for request or song',
  title: 'Requests',
  hideClosed: 'Hide closed',
} as const
